import { DEFAULT_LOCALE, type SupportedLocale } from "./config";

type LocalisedCopyMap<T> = Partial<Record<SupportedLocale, T>> & Record<typeof DEFAULT_LOCALE, T>;

/** Resolve webapp copy for the active locale, falling back to en-GB when a locale is not translated yet. */
export function pickAppCopy<T>(map: LocalisedCopyMap<T>, locale: SupportedLocale): T {
    return map[locale] ?? map[DEFAULT_LOCALE];
}
